import { ApiService } from '@b2b/common/services/api/types';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { ValidateService } from '@b2b/common/services/validate';
import { TODO, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IScope, ITimeoutService } from 'angular';

TemplatesCreatePricingController.$inject = [
  '$scope',
  '$state',
  '$timeout',
  'HelpersService',
  'TemplatesService',
  'DiscountsService',
  'ApiService',
  'ValidateService',
  'WizardFactory',
  'ThemesHelperService',
  '$uibModal',
];

function TemplatesCreatePricingController(
  $scope: IScope & { templatesCreatePricing: TODO; pricingGridOptions: TODO },
  $state: StateService,
  $timeout: ITimeoutService,
  HelpersService: TODO,
  TemplatesService: TODO,
  DiscountsService: TODO,
  ApiService: ApiService,
  ValidateService: ValidateService,
  WizardFactory: TODO,
  ThemesHelperService: ThemesHelperService,
  $uibModal: UIBModalService
) {
  const CONSTANTS = {
    PRICE_LIST_MODAL: {
      OK: 'Change Price List',
      CANCEL: 'Cancel',
      TITLE: 'Change may affect Member Rules',
      MESSAGE:
        'Be sure to verify all member rules still apply for tickets sold at the Template, ' +
        'Schedule, and Instance levels.',
    },
  };

  const ctrl = {
    model: {
      priceLists: [],
      salesChannels: [],
    },

    loading: {
      list: false,
      discount: false,
    },

    isLoaded: false,

    validators: [] as TODO[],
    wizard: {} as TODO,
    generalWizard: {} as TODO,
    template: {} as TODO,
    priceLists: [] as TODO[],
    currentPriceList: null as TODO | null,
    isSubmitted: false,
    hasValidPriceList: false,
    allowedTabs: ['general', 'accounts', 'members', 'coupons'],
    tab: 'general',
    tabErrors: {},

    ticketExpirationSetting: [
      {
        name: 'expireFromEventDate',
        label: 'event start',
      },
      {
        name: 'expireFromPurchaseDate',
        label: 'purchase',
      },
    ],

    purchaseAvailabilitySetting: [
      {
        name: 'before',
        label: 'Stop before event starts',
        hours: '1',
        minutes: '',
      },
      {
        name: 'when',
        label: 'Stop when event starts',
        hours: '',
        minutes: '',
      },
      {
        name: 'after',
        label: 'Allow after event starts',
        forDuration: true,
        hours: '1',
        minutes: '',
      },
    ],

    // ticketExpirationSelection: 'expireFromEventDate' as string | { name: string; label: string }, // TODO: APP-4332 - is this really the type?
    ticketExpirationSelection: 'expireFromEventDate' as TODO, // TODO: APP-4332 - is this really the type?
    purchaseAvailabilitySelection: {} as TODO, // TODO: APP-4332 - is this a good default?

    templatesService: TemplatesService,

    init: function () {
      let tab = ($state.params && $state.params.tab) || '';
      tab = tab.toLowerCase();

      $scope.$on('TemplatesService::Update', ctrl.onTemplatesServiceUpdate);
      $scope.$on('TemplatesCreateController::Save', ctrl.onTemplatesCreateControllerSave);
      $scope.$on('TemplatesCreatePricingController::TabCheck', ctrl.onTabCheck);
      $scope.$on('$destroy', $scope.$watchCollection('templatesCreatePricing.loading', ctrl.onLoadingUpdate));

      ctrl.initWizard(false);

      ctrl.clearTabErrors();

      ValidateService.addFieldTests(ctrl.wizard.getStep('pricing').validators);
      ValidateService.addFieldTests(ctrl.generalWizard.getStep('general').validators);

      ctrl.template = TemplatesService.getModel();
      ctrl.ticketExpirationSelection = ctrl.template.ticketDetails.expireFromEventDate
        ? ctrl.ticketExpirationSetting[0]
        : ctrl.ticketExpirationSetting[1];
      ctrl.refreshPurchaseAvailabilitySelection();

      ctrl.currentPriceList = TemplatesService.processSalesChannels(TemplatesService.getPriceList());
      TemplatesService.setMemberOnly(ctrl.template.memberOnlyEvent);

      TemplatesService.setIsTabLoading(true, 'pricing');
      ctrl.getPriceLists();
      ctrl.getDiscountCodes();

      // Next tick
      $timeout(() => {
        $scope.$broadcast('TemplatesCreatePricing::Update', { view: ctrl.tab });
      }, 0);

      console.log('TemplatesCreatePricingController::init');

      if (tab && ctrl.allowedTabs.indexOf(tab) > -1) {
        ctrl.setTab(tab);
      }
    },

    initWizard: function (validate: boolean) {
      ctrl.wizard = new WizardFactory();
      ctrl.wizard.init({
        name: 'pricing',
        validators: [
          {
            field: 'templates-create-pricing-price-list',
            equal: {
              message: 'You must select a price list for the event',
              test: function () {
                const reviewState = TemplatesService.getReviewState();
                const validSave = reviewState === 'draft' || (reviewState === 'published' && ctrl.hasPrices());

                return [validSave, true];
              },
            },
          },
        ],
      });

      ctrl.generalWizard = new WizardFactory();
      ctrl.generalWizard.init({
        name: 'general',
        validators: [
          {
            field: 'templates-create-pricing-ticket-duration',
            greater: {
              message: 'Please enter a value of 0 or greater',
              test: function () {
                return { greater: ctrl.template.ticketDetails.ticketDurationDays, less: -1 };
              },
            },
          },
          {
            field: 'templates-create-pricing-ticket-checkin-before',
            greater: {
              message: 'Please enter a value of 0 or greater',
              test: function () {
                return { greater: ctrl.template.ticketDetails.checkInWindow.minutesBefore, less: -1 };
              },
            },
          },
          {
            field: 'templates-create-pricing-purchase-availability-minutes',
            oneOrGreater: {
              message: 'Please enter a value of 1 or greater for hours or minutes',
              test: function () {
                let value = 0;
                // Allow empty as we default to 0 when 'for duration of' is selected
                if (
                  ctrl.purchaseAvailabilitySelection.minutes === '' &&
                  ctrl.purchaseAvailabilitySelection.hours === ''
                ) {
                  value = 1;
                } else {
                  if (ctrl.purchaseAvailabilitySelection.minutes !== '') {
                    value = ctrl.purchaseAvailabilitySelection.minutes;
                  }
                  if (ctrl.purchaseAvailabilitySelection.hours !== '') {
                    value = value + ctrl.purchaseAvailabilitySelection.hours * 60;
                  }
                }

                return value;
              },
            },
          },
          {
            field: 'templates-create-pricing-ticket-checkin-after',
            greater: {
              message: 'Please enter a value of 0 or greater',
              test: function () {
                return { greater: ctrl.template.ticketDetails.checkInWindow.minutesAfter, less: -1 };
              },
            },
          },
          {
            field: 'templates-create-pricing-rebooking-fee',
            greater: {
              message: 'Please enter a value of 0 or greater',
              test: function () {
                return { greater: ctrl.template.rebookingFee, less: -1 };
              },
            },
          },
        ],
      });

      if (validate) {
        ctrl.validate();
      }
    },

    validate: function () {
      $timeout(() => {
        ctrl.wizard.validate();
        ctrl.generalWizard.validate();

        $scope.$emit('TemplatesCreateController::TabCheck', {
          tab: 'pricing',
          invalid: ctrl.wizard.hasErrors('pricing'),
        });
        $scope.$emit('TemplatesCreatePricingController::TabCheck', {
          tab: 'general',
          invalid: ctrl.generalWizard.hasErrors('general'),
        });
      }, 0);
    },

    clearTabErrors: function () {
      for (const error in ctrl.tabErrors) {
        if (ctrl.tabErrors.hasOwnProperty(error)) {
          ctrl.tabErrors[error] = false;
        }
      }
    },

    isValid: function (field: string) {
      if (ctrl.isSubmitted) {
        return ValidateService.check(ctrl.validators, field);
      }

      return true;
    },

    getError: function (field: string) {
      return ValidateService.getError(field);
    },

    getPriceLists: function () {
      ctrl.loading.list = true;
      ApiService.price.lists
        .list(HelpersService.getPaginator())
        .then((response) => ctrl.success.getPriceLists(response))
        .catch((response) => ctrl.error.getPriceLists(response));
    },

    getPriceList: function (id: number) {
      ApiService.price.lists
        .detail(id)
        .then((response) => ctrl.success.getPriceList(response))
        .catch((response) => ctrl.error.getPriceList(response));
    },

    getDiscountCodes: function () {
      ctrl.loading.discount = true;
      ApiService.discounts
        .list('v2', HelpersService.getPaginator())
        .then((response) => ctrl.success.getDiscountCodes(response))
        .catch((response) => ctrl.error.getDiscountCodes(response));
    },

    isTab: function (tab: string) {
      return ctrl.tab === tab;
    },

    setTab: function (tab: string) {
      ctrl.tab = tab;
      $scope.$broadcast('TemplatesCreatePricing::Update', { view: ctrl.tab });
    },

    hasTabErrors: function (tab: string) {
      return ctrl.tabErrors[tab];
    },

    // Price lists
    hasPriceLists: function () {
      return ctrl.priceLists.length > 0 && ctrl.priceLists[0];
    },

    hasPrices: function () {
      ctrl.hasValidPriceList = Array.isArray(ctrl.currentPriceList?.prices) ? true : false;
      return ctrl.hasValidPriceList;
    },

    findPriceList: function (id) {
      if (id) {
        for (let i = 0, ii = ctrl.priceLists.length; i < ii; i++) {
          if (ctrl.priceLists[i].id === id) {
            return {
              index: i,
              list: TemplatesService.processSalesChannels(ctrl.priceLists[i]),
            };
          }
        }
      }

      return false;
    },

    // Discount codes
    findDiscountCode: function (id) {
      return DiscountsService.find(id);
    },

    isEnableSalesRules: function () {
      return ThemesHelperService.getCompany('enableSalesView');
    },

    success: {
      init: function (response) {},

      getPriceList: function (response) {
        ctrl.currentPriceList = TemplatesService.processSalesChannels(response.data.payload.list);
      },

      getPriceLists: function (response) {
        ctrl.priceLists = response.data.payload.list;

        for (let i = 0, ii = ctrl.priceLists.length; i < ii; i++) {
          ctrl.priceLists[i] = TemplatesService.processSalesChannels(ctrl.priceLists[i]);
        }

        if (ctrl.currentPriceList && ctrl.currentPriceList.hasOwnProperty('id')) {
          const priceList = ctrl.findPriceList(ctrl.currentPriceList.id);
          if (priceList) {
            ctrl.priceLists[priceList.index] = ctrl.currentPriceList;
          }
        }

        ctrl.loading.list = false;

        // Next tick
        $timeout(() => {
          ctrl.validate();
        }, 0);
      },

      getDiscountCodes: function (response) {
        DiscountsService.setModel(response.data.payload.list);
        ctrl.loading.discount = false;
      },
    },

    error: {
      init: function (response) {},
      getPriceList: function (response) {
        ctrl.error.generic(response);
      },
      getPriceLists: function (response) {
        ctrl.error.generic(response);
        ctrl.loading.list = false;

        // Next tick
        $timeout(() => {
          ctrl.validate();
        }, 0);
      },
      getDiscountCodes: function (response) {
        ctrl.error.generic(response);
        ctrl.loading.discount = false;
      },
      generic: function (response) {
        $scope.$emit('TemplatesCreateController::Error', { message: response.data.error });
      },
    },

    onLoadingUpdate: function () {
      if (!ctrl.loading.list && !ctrl.loading.discount) {
        TemplatesService.setIsTabLoading(false, 'pricing');
        ctrl.isLoaded = true;
      }
    },

    onTemplatesCreateControllerSave: function (e, data) {
      TemplatesService.setPriceList(ctrl.currentPriceList);

      TemplatesService.setExpireFromEventDate(
        ctrl.ticketExpirationSelection.name === ctrl.ticketExpirationSetting[0].name
      );

      TemplatesService.setPurchaseAvailability(
        ctrl.purchaseAvailabilitySelection.name,
        ctrl.getPurchaseAvailabilityMinutes()
      );

      ctrl.validate();

      ctrl.isSubmitted = true;
    },

    onTemplatesServiceUpdate: function (e, data) {
      ctrl.template = TemplatesService.getModel();

      // Next Tick
      $timeout(() => {
        // Find in priceLists
        const priceList = ctrl.findPriceList(TemplatesService.getPriceList().id);
        if (priceList) {
          // Override matching price list with what is in the template
          ctrl.priceLists[priceList.index] = TemplatesService.getPriceList();
          // Assign to currentPriceList
          ctrl.currentPriceList = TemplatesService.processSalesChannels(ctrl.priceLists[priceList.index]);
        }
        // Check restrictions
        TemplatesService.setMemberOnly(ctrl.template.memberOnlyEvent);

        ctrl.ticketExpirationSelection = ctrl.template.ticketDetails.expireFromEventDate
          ? ctrl.ticketExpirationSetting[0]
          : ctrl.ticketExpirationSetting[1];
        ctrl.refreshPurchaseAvailabilitySelection();
      }, 0);
    },

    refreshPurchaseAvailabilitySelection: function () {
      if (ctrl.template.ticketDetails.purchaseAvailability) {
        ctrl.purchaseAvailabilitySelection = ctrl.purchaseAvailabilitySetting.filter((setting) => {
          return setting.name === ctrl.template.ticketDetails.purchaseAvailability.timeFrame;
        })[0];

        // Set hours / minutes
        if (ctrl.template.ticketDetails.purchaseAvailability.minutes) {
          ctrl.purchaseAvailabilitySelection.hours = Math.floor(
            ctrl.template.ticketDetails.purchaseAvailability.minutes / 60
          );
          ctrl.purchaseAvailabilitySelection.minutes = ctrl.template.ticketDetails.purchaseAvailability.minutes % 60;
        } else {
          ctrl.purchaseAvailabilitySelection.hours = '';
          ctrl.purchaseAvailabilitySelection.minutes = '';
        }

        // 0 minutes for 'after' time frame means time is for the duration of the event
        if (
          ctrl.template.ticketDetails.purchaseAvailability.timeFrame === 'after' &&
          ctrl.template.ticketDetails.purchaseAvailability.minutes !== 0
        ) {
          ctrl.purchaseAvailabilitySelection.forDuration = false;
        }
      } else {
        // default
        ctrl.purchaseAvailabilitySelection = ctrl.purchaseAvailabilitySetting[1];
      }
    },

    getPurchaseAvailabilityMinutes: function () {
      const minutes = parseInt(ctrl.purchaseAvailabilitySelection.minutes, 10) || 0;
      const hoursInMinutes = (parseInt(ctrl.purchaseAvailabilitySelection.hours, 10) || 0) * 60;
      let total = 0;

      if (ctrl.purchaseAvailabilitySelection.name === 'after' && !ctrl.purchaseAvailabilitySelection.forDuration) {
        total = minutes + hoursInMinutes;
      } else if (ctrl.purchaseAvailabilitySelection.name === 'before') {
        total = minutes + hoursInMinutes;
      }

      return total;
    },

    onRestrictMembersUpdate: function (memberOnly, o) {
      TemplatesService.setMemberOnly(memberOnly);

      if (memberOnly) {
        if (ctrl.isTab('accounts')) {
          ctrl.setTab('general');
        }
      }
    },

    onTabCheck: function (e, data) {
      ctrl.tabErrors[data.tab] = data.invalid;
      // Propagate the event to the listening parent controller the chain
      if (data.invalid) {
        $scope.$emit('TemplatesCreateController::TabCheck', {
          tab: 'pricing',
          invalid: data.invalid,
        });
      }
    },

    onCurrentPriceListUpdate: function (newPriceList, oldPriceList) {
      const model = TemplatesService.getModel();
      const entitlement = model.entitlementConfiguration;
      const showPopup = entitlement && entitlement.entitlementConfig.length > 0;

      if (showPopup) {
        ctrl.currentPriceList = ctrl.priceLists.filter((priceList) => {
          return priceList.id === oldPriceList;
        })[0];

        ctrl
          .promptUser(
            CONSTANTS.PRICE_LIST_MODAL.TITLE,
            CONSTANTS.PRICE_LIST_MODAL.MESSAGE,
            CONSTANTS.PRICE_LIST_MODAL.OK
          )
          .then(() => {
            // user has confirmed
            ctrl.currentPriceList = newPriceList;
            TemplatesService.setPriceList(ctrl.currentPriceList);
            $scope.$broadcast('TemplatesCreatePricing::Update', { view: ctrl.tab });
          });
      } else {
        ctrl.currentPriceList = newPriceList;
        TemplatesService.setPriceList(ctrl.currentPriceList);
        $scope.$broadcast('TemplatesCreatePricing::Update', { view: ctrl.tab });
      }
    },

    promptUser: function (title, message, saveText) {
      const modal = $uibModal.open({
        templateUrl: 'views/application/views/templates/create/pricing/pricing-popup.tpl.html',
        size: 'md',
        controller: [
          '$uibModalInstance',
          function ($uibModalInstance) {
            // TODO: APP-4332 - refactor to remove implicit `this` reference
            this.$uibModalInstance = $uibModalInstance;
            this.title = title;
            this.saveText = saveText;
            this.message = message;
          },
        ],
        controllerAs: '$ctrl',
      });

      return modal.result;
    },
  };

  $scope.pricingGridOptions = {
    enableRowSelection: false,
    paginate: false,
    multiSelect: false,

    columnDefs: [
      {
        field: 'personType.displayOrder',
        displayName: 'Order',
        visible: false,
      },
      {
        field: 'personType.name',
        displayName: 'Ticket Type',
      },
      {
        field: 'personType.description',
        displayName: 'Description',
      },
      {
        field: 'price',
        displayName: 'Price',
        cellFilter: 'currency',
        editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
        enableCellEdit: true,
        enableCellEditOnFocus: true,
      },
      {
        field: 'salesChannels[0].enabled',
        displayName: 'Web',
        cellTemplate:
          '<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Ticket Type {{ row.entity.personType.name }} Web</span></label></div>',
        visible: true,
      },
      {
        field: 'salesChannels[1].enabled',
        displayName: 'POS',
        cellTemplate:
          '<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Ticket Type {{ row.entity.personType.name }} POS</span></label></div>',
        visible: true,
      },
      {
        field: 'salesChannels[2].enabled',
        displayName: 'Reseller',
        cellTemplate:
          '<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" data-ng-disabled="grid.appScope.templatesCreatePricing.template.memberOnlyEvent" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Ticket Type {{ row.entity.personType.name }} Reseller</span></label></div>',
        visible: true,
      },
      {
        field: 'salesChannels[3].enabled',
        displayName: 'Customer Rep.',
        cellTemplate:
          '<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Ticket Type {{ row.entity.personType.name }} Customer Rep.</span></label></div>',
        visible: true,
      },
      {
        field: 'salesChannels[5].enabled',
        displayName: 'Kiosk',
        cellTemplate:
          '<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Ticket Type {{ row.entity.personType.name }} Kiosk</span></label></div>',
        visible: true,
      },
    ],
  };

  $scope.templatesCreatePricing = ctrl;
  ctrl.init();
}

export const TemplatesCreatePricingControllerModule = angular
  .module('acme.view.application.templates.create.pricing.controllers', [
    uiRouter,
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.templates',
    'acme.common.service.discounts',
    'acme.common.service.themesHelper',
    'acme.common.service.validate',
    'acme.common.factory.wizard',
    'acme.application.templates.create.pricing.accounts.controllers',
    'acme.application.templates.create.pricing.coupons.controllers',
    'acme.application.templates.create.pricing.members.controllers',
    'acme.application.templates.create.pricing.ticketsRules.controllers',
    'acme.application.templates.create.pricing.salesRules.controllers',
  ])
  .controller('TemplatesCreatePricingController', TemplatesCreatePricingController).name;
